module.exports = new __parcel__URL__("Fundraising.0a1781f3.svg").toString();